module.exports = __webpack_public_path__ + "media/images/a_three-8d1ae04672f03bc0e166f832b2a4edd7.png";